import { createReducer, on } from '@ngrx/store';
import * as appNotificationsActions from '../actions/app-notification.action';
import { AppNotification } from 'src/app/shared/model/api/AppNotification';
import { isNil } from 'lodash-es';
//import { stat } from 'fs';
//
// Reducer Interface
//
export interface IAppNotificationState {
  showPanel : boolean;
  enableToast : boolean;
  // list of all notifications
  // TODO: refactor to a better multipurpose class name
  notificationsList : AppNotification[];//DealSummaryView
  toastMessages : AppNotification[];//CustomerDealSummary[]
  comments:any[],
  isToggle: boolean;
}
//
// Initial State
//
export const APP_NOTIFICATION_INITIAL_STATE: IAppNotificationState = {
   showPanel: false,
   enableToast: true,
   notificationsList : [],//notificationsList : null,
   toastMessages: [],
   comments: [],
   isToggle: true
};


export const AppNotificationStateReducer = createReducer(
  APP_NOTIFICATION_INITIAL_STATE,
  on(appNotificationsActions.AppNotificationShowPanel, (state) => ({ ...state, showPanel: true })),
  on(appNotificationsActions.AppNotificationHidePanel, (state) => ({ ...state, showPanel: false })),
  on(appNotificationsActions.AppNotificationToggleOn, (state) => ({ ...state, isToggle: true })),
  on(appNotificationsActions.AppNotificationToggleOff, (state) => ({ ...state, isToggle: false })),
  on(appNotificationsActions.AppNotificationEnableToast, (state) => ({ ...state, enableToast: true })),
  on(appNotificationsActions.AppNotificationDisableToast, (state) => ({ ...state, enableToast: false })),
  on(appNotificationsActions.AppNotificationClearToasterMessages, (state) => ({ ...state, toastMessages: [] })),
  on(appNotificationsActions.AppNotificationClearAllSucceed, (state) => ({ ...state, notificationsList: [] })),
  on(appNotificationsActions.AppNotificationInitialFetchSucceed, (state, { response }) => _setNotifications(state, response)),
  on(appNotificationsActions.AppNotificationRemove, (state, { payload }) => _removeNotification(state, payload)),
  on(appNotificationsActions.AppNotificationUpdate, (state, { payload }) => _updateNotifications(state, payload)),
  on(appNotificationsActions.AddChatComment, (state, { payload }) => addComment(state, payload)),
  on(appNotificationsActions.ClearChatComment, (state, { payload }) => clearComment(state, payload)),
  on(appNotificationsActions.ClearAllChatComments, (state) => ({ ...state, comments: [] })),
);


function _updateNotifications(state: IAppNotificationState, action: any): IAppNotificationState {
  const toast = [...state.toastMessages];
  const notification = action;
  if (state.enableToast) {
    if (state.isToggle) {
      toast.push(notification);
    } else {
      if (notification.deal.isToast)
        {toast.push(notification);}
    }
  }

  let currentNotifications = [...state.notificationsList];

  if (notification.deal?.creditFlag) {
    currentNotifications = currentNotifications.filter(e => {
      if(e.deal.dealTransactionId != notification.deal.dealTransactionId){
        return true;
      }else if(e.deal.dealTransactionId == notification.deal.dealTransactionId && e.deal?.creditFlag){
        return false;
      }else{
        return true;
      }
    });
  } else{
    currentNotifications = currentNotifications.filter(e => {
      if(e.deal.dealTransactionId != notification.deal.dealTransactionId){
        return true;
      }else if(e.deal.dealTransactionId == notification.deal.dealTransactionId && e.deal?.creditFlag){
        return true;
      }else{
        return false;
      }
    });
  }
  currentNotifications.unshift(notification);
  return { ...state, notificationsList: currentNotifications, toastMessages: toast };
}

function _removeNotification(state: IAppNotificationState, action: string){
    const notification = state.notificationsList.filter(e => e.deal.dealTransactionId != action);
    return {...state, notificationsList: notification};
}
function _setNotifications(state: IAppNotificationState, action): IAppNotificationState {
  const sortedNotifications = action.sort(function (a, b) {
    return new Date(b.deal.updatedDate).getTime() - new Date(a.deal.updatedDate).getTime();
  });
  return { ...state, notificationsList: sortedNotifications };
}
function addComment(state: IAppNotificationState, action){
  const comments = state.comments.filter(comment => comment.deal.dealTransactionId !== action.deal.dealTransactionId)
  return {...state, comments: [action, ...comments]}
}
function clearComment(state: IAppNotificationState, action){
  const comments = state.comments.filter(comment => comment.deal.dealTransactionId !== action.deal.dealTransactionId)
  return {...state, comments: comments}
}
